import BaseService from './BaseService'
import { PresenceStatus } from '../models/enums'

export default class PresenceService extends BaseService {
  constructor(host, options) {
    super(host, options)
  }

  mounted() {
    this._data = {}
  }

  dispose() {
    this._data = null
  }

  reactToPresenceEvent({ data }) {
    this.set(data['from'], PresenceStatus.resolve(data['type']))
  }

  set(id, presence) {
    const hasChanged = this._data[id] !== presence
    if (!hasChanged) return

    this._data[id] = presence
    const user = this.host.models.User.inject({ id, presence })

    this.emit('change', {
      presence,
      user,
      userId: id,
    })
  }

  get(id) {
    if (id === this.host.currentUserId) return PresenceStatus.AVAILABLE

    return this._data[id] || PresenceStatus.UNKNOWN
  }
}
